import React from 'react';
import { earnedText, earnedPayText, liveEarned, myShareOf, computeCardActiveTime } from '@battleops/shared';
import { useShareDocs } from '@battleops/client/src/data/usePerson';
import { useSession } from '@battleops/client/src/context/SessionContext';
import { useTasks } from '@battleops/client/src/context/TaskContext';
import { useNow } from '../../hooks';
import Icon from '../Icon';

// "$140 earned on this task" (docs/plans/people.md P7) — the phone's EarnedLine on the desk: what a fixed-job task is
// worth to YOU (your share of its labour, from your own job-pay doc), live while your timer runs on it. Never the
// task's or the job's number; nothing when the task earns you nothing. On an hourly (T&M) job (v0.1.258): your hours
// and what they bill, plus your pay — no share.
export default function EarnedLine({ task }) {
  const { identity } = useSession();
  const { timer } = useTasks();
  const uid = identity?.uid || null;
  const docs = useShareDocs(uid);
  const mine = timer?.taskId === task?.id && !timer?.pauseType;
  const now = useNow(mine ? 1000 : 60000);
  const pub = task && uid ? myShareOf(docs, task.projectId, uid, task.id) : null;
  const e = liveEarned(pub, mine ? computeCardActiveTime(timer, now) : 0);
  if (!e) return null;
  return (
    <div role="status" style={{ display: 'flex', alignItems: 'center', gap: 8, minHeight: 40, padding: '0 14px', margin: '0 0 14px', borderRadius: 12, border: '1px solid var(--c-success)', background: 'color-mix(in srgb, var(--c-success) 12%, transparent)', color: 'var(--c-success)', fontWeight: 800, fontVariantNumeric: 'tabular-nums' }}>
      <Icon name={e.mode === 'hourly' ? 'clock' : e.done ? 'check-circle' : 'trending-up'} size={15} />
      <span style={{ flex: 1 }}>{earnedText(e)}</span>
      {e.live ? <span style={{ width: 6, height: 6, borderRadius: 3, background: 'var(--c-success)' }} /> : null}
      {earnedPayText(e) ? <span style={{ color: 'var(--c-text-tertiary)', fontWeight: 600, fontSize: 12.5 }}>{earnedPayText(e)}</span> : null}
      {e.mode !== 'hourly' && pub?.pct != null && pub.pct < 100 ? <span style={{ color: 'var(--c-text-tertiary)', fontWeight: 600, fontSize: 12.5 }}>your share {pub.pct}%</span> : null}
    </div>
  );
}
